/** Dot path with numeric segments for arrays, e.g. `stats.items.0.label` */

export function getDot(obj, dotPath) {
  if (obj == null || !dotPath) return undefined;
  const parts = dotPath.split(".").filter(Boolean);
  let cur = obj;
  for (const p of parts) {
    if (cur == null) return undefined;
    const key = /^\d+$/.test(p) ? Number(p) : p;
    cur = cur[key];
  }
  return cur;
}

export function setDot(root, dotPath, value) {
  const parts = dotPath.split(".").filter(Boolean);
  if (parts.length === 0) return root;
  const out = root !== undefined && root !== null ? JSON.parse(JSON.stringify(root)) : {};
  let cur = out;
  for (let i = 0; i < parts.length - 1; i++) {
    const p = parts[i];
    const nk = parts[i + 1];
    const key = /^\d+$/.test(p) ? Number(p) : p;
    const needArray = /^\d+$/.test(nk);
    const existing = cur[key];
    // Recreate the container when it's missing OR its type conflicts with what
    // the next segment needs (e.g. a stray [] where we must write string keys).
    // Without this, writing "contact.form.name" onto an array silently drops the
    // value on JSON.stringify and wipes sibling fields.
    const okType =
      existing != null && typeof existing === "object" && Array.isArray(existing) === needArray;
    if (!okType) {
      cur[key] = needArray ? [] : {};
    }
    cur = cur[key];
  }
  const last = parts[parts.length - 1];
  const lastKey = /^\d+$/.test(last) ? Number(last) : last;
  cur[lastKey] = value;
  return out;
}

export function deleteDot(root, dotPath) {
  const parts = dotPath.split(".").filter(Boolean);
  if (parts.length === 0 || root == null) return root;
  const out = JSON.parse(JSON.stringify(root));
  let cur = out;
  for (let i = 0; i < parts.length - 1; i++) {
    const p = parts[i];
    const key = /^\d+$/.test(p) ? Number(p) : p;
    if (cur[key] == null || typeof cur[key] !== "object") return out;
    cur = cur[key];
  }
  const last = parts[parts.length - 1];
  const lastKey = /^\d+$/.test(last) ? Number(last) : last;
  if (cur && typeof cur === "object") delete cur[lastKey];
  return out;
}

export function formatSourceSnippet(v, max = 72) {
  if (v === undefined || v === null) return "—";
  const s = typeof v === "string" ? v : JSON.stringify(v);
  if (s.length <= max) return s;
  return `${s.slice(0, max)}…`;
}
